// extracted by mini-css-extract-plugin
export default {"PFSWhoWeAreContent":"PFSWhoWeAreContent_PFSWhoWeAreContent__K8geM"};